export default __webpack_public_path__ + "static/media/fauna-db-explorer.92cf04c5.png";